module.exports = __webpack_public_path__ + "static/media/12.Core Cutting Machine.54ddcd10.jpg";